var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoaccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "614px",
    height: "407.42px",
    viewBox: "0 0 614 407.42",
    style: {
      enableBackground: "new 0 0 614 407.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#44BAC5;}\n\t.st1{fill:#222931;}\n\t.st2{fill:#45B9C5;}\n\t.st3{fill:none;}\n\t.st4{opacity:0.5412;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#1B909C;}\n\t.st7{fill:#979A9F;}\n\t.st8{fill:#E7E4E5;}\n\t.st9{fill:#EFEEEF;}\n\t.st10{opacity:0.4588;fill:#AFD1D3;}\n\t.st11{opacity:0.2392;fill:#45B9C5;}\n\t.st12{fill:#C4C5C4;}\n\t.st13{fill:#222930;}\n\t.st14{fill:none;stroke:#222931;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#222931;stroke-width:9;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.33,
    y: 351.38,
    className: "st0",
    width: 107.7,
    height: 27.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 302.43,
    className: "st0",
    width: 230.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.05,
    y: 327.41,
    className: "st0",
    width: 22,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.33,
    y: 198.36,
    className: "st0",
    width: 317.51,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.33,
    y: 145.36,
    className: "st0",
    width: 226.51,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 93.36,
    className: "st0",
    width: 268.44,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 45.36,
    className: "st0",
    width: 175.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.84,
    y: 93.36,
    className: "st0",
    width: 19.81,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.04,
    y: 223.36,
    className: "st0",
    width: 42,
    height: 27.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 187.33,
    cy: 365.38,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 293.33,
    cy: 365.38,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 82.33,
    cy: 316.38,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 313.05,
    cy: 316.38,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 375.05,
    cy: 341.38,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.98,351.38c-5.72,0-10.35-4.69-10.35-10.47c0-5.78,4.63-10.47,10.35-10.47c0.12,0,0.23,0.01,0.35,0.02 v-7.55h-82.98v7.36c0.43-0.05,0.86-0.08,1.3-0.08c5.72,0,10.35,4.8,10.35,10.74s-4.63,10.74-10.35,10.74 c-0.44,0-0.87-0.03-1.3-0.08v0.33h82.98v-0.55C279.21,351.37,279.1,351.38,278.98,351.38z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 397.05,
    cy: 341.38,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 455.84,
    cy: 288.43,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 131.4,
    cy: 265.33,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.4,222.33v3.97c6.9,0,12.5,5.61,12.5,12.53c0,6.92-5.6,12.53-12.5,12.53v0.97h320.64v-30H145.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.55,273.93v5.42c0.12,0,0.24-0.02,0.37-0.02c6.38,0,11.55,5.17,11.55,11.55s-5.17,11.55-11.55,11.55 c-0.12,0-0.25-0.01-0.37-0.02v0.52h272v-29H183.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.84,251.57v-0.21h-1.4C426.91,251.4,427.38,251.47,427.84,251.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.39,274.41c-6.38,0-11.55-5.17-11.55-11.55c0-6.03,4.61-10.97,10.5-11.5H131.4v27.95h296.44v-5.17 C427.05,274.31,426.23,274.41,425.39,274.41z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 466.04,
    cy: 237.33,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 510.04,
    cy: 237.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 552.04,
    cy: 237.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96.33,
    cy: 212.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 187.33,
    cy: 159.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.4,
    cy: 107.33,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.29,93.36c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c0.26,0,0.51,0.02,0.76,0.04v-5.04 H243.59v5.01c5.36,0.19,9.64,4.59,9.64,10c0,5.41-4.28,9.82-9.64,10.01v2.93h117.46v-2.96 C360.8,93.34,360.55,93.36,360.29,93.36z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 207.4,
    cy: 59.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 383.05,
    cy: 59.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 427.84,
    cy: 107.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 469.84,
    cy: 107.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 489.64,
    cy: 107.33,
    r: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M597.79,278.69v-9c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v9H597.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M597.79,294.1v-9h4v9c0,1.1-0.9,2-2,2l0,0C598.69,296.1,597.79,295.21,597.79,294.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603,279.89h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V279.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M587.58,279.89h9v4h-9c-1.1,0-2-0.9-2-2l0,0C585.58,280.79,586.48,279.89,587.58,279.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.79,278.69v-9c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v9H15.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.79,294.1v-9h4v9c0,1.1-0.9,2-2,2h0C16.69,296.1,15.79,295.21,15.79,294.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21,279.89h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V279.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.58,279.89h9v4h-9c-1.1,0-2-0.9-2-2l0,0C3.58,280.79,4.48,279.89,5.58,279.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M547.36,361.24v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H547.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M547.36,374.47v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99 C547.87,375.63,547.36,375.11,547.36,374.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M551.66,362.24h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V362.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M538.42,362.24h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99 C537.27,362.75,537.79,362.24,538.42,362.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.39,361.24v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H66.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.39,374.47v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99C66.91,375.63,66.39,375.11,66.39,374.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.69,362.24h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V362.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.46,362.24h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99C56.3,362.75,56.82,362.24,57.46,362.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M530.94,87.91v-7.24c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H530.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M530.94,100.05v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74 C531.46,101.21,530.94,100.69,530.94,100.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.92,88.83h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.78,88.83h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C521.62,89.35,522.14,88.83,522.78,88.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.62,87.91v-7.24c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H86.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.62,100.05v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74C87.14,101.21,86.62,100.69,86.62,100.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.59,88.83h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.46,88.83h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C77.3,89.35,77.82,88.83,78.46,88.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491.65,151.19v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H491.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491.65,160.98v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C492.17,162.13,491.65,161.62,491.65,160.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M494.92,151.95h5.75c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V151.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M485.14,151.95h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16v-0.2C483.98,152.47,484.5,151.95,485.14,151.95 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.97,151.19v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H125.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.97,160.98v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C126.49,162.13,125.97,161.62,125.97,160.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.24,151.95H135c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V151.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.46,151.95h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16v-0.2C118.3,152.47,118.82,151.95,119.46,151.95 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.94,192.61v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H559.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.94,206.36v-8.26h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C560.45,207.52,559.94,207,559.94,206.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M564.4,193.65h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V193.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M550.64,193.65h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11C549.49,194.16,550,193.65,550.64,193.65z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.75,192.61v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H61.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.75,206.36v-8.26h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C62.27,207.52,61.75,207,61.75,206.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.21,193.65h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V193.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.46,193.65h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11C51.3,194.16,51.82,193.65,52.46,193.65z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 214.88,
    y: 90.36,
    className: "st5",
    width: 200.95,
    height: 132.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.84,
    y: 90.36,
    className: "st6",
    width: 203,
    height: 13.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.16,101.46v-4.5c0-0.55,0.45-1,1-1h9.5c0.55,0,1,0.45,1,1v4.5c0,0.55-0.45,1-1,1h-9.5 C221.61,102.46,221.16,102.01,221.16,101.46z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.56,287.72v-0.92c0-3.87,3.13-7,7-7H431.8c3.87,0,7,3.13,7,7v0.92c0,3.87-3.13,7-7,7H200.56 C196.7,294.72,193.56,291.59,193.56,287.72z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "433.21,287.4 437.93,284.03 439.2,279.5 421.97,228.42 414.83,227.19 215.96,227.62 210.42,227.62  207.47,232.42 193.56,279.8 195.16,284.73 199.84,288.05  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.61,99.46v-0.5c0-1.66,1.34-3,3-3h76.57c1.66,0,3,1.34,3,3v0.5c0,1.66-1.34,3-3,3h-76.57 C237.96,102.46,236.61,101.11,236.61,99.46z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 369.09,
    cy: 99.24,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 379.34,
    cy: 99.24,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 389.34,
    cy: 99.24,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 399.34,
    cy: 99.21,
    r: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.88,
    y: 110.1,
    className: "st10",
    width: 66,
    height: 108
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 146.1,
    className: "st9",
    width: 46,
    height: 74.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 110.26,
    className: "st11",
    width: 46,
    height: 32.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.88,
    y: 110.26,
    className: "st11",
    width: 76,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.88,
    y: 165.4,
    className: "st11",
    width: 76,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.88,
    y: 192.4,
    className: "st9",
    width: 76,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.88,
    y: 136.96,
    className: "st9",
    width: 76,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M279.34,276.96v-11c0-1.66,1.34-3,3-3h64c1.66,0,3,1.34,3,3v11c0,1.66-1.34,3-3,3h-64 C280.68,279.96,279.34,278.62,279.34,276.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "229.57,258.63 234.53,233.63 398.14,233.63 403.73,258.63  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M438.8,280.31v7.42c0,0.48-0.05,0.95-0.14,1.41c-0.65,3.19-3.47,5.59-6.86,5.59H200.84c-3.87,0-7-3.13-7-7 v-7.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M212.84,216.31v-121c0-3.87,3.13-7,7-7h189c3.87,0,7,3.13,7,7v121c0,3.87-3.13,7-7,7h-189 C215.97,223.31,212.84,220.17,212.84,216.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.84,280.31l15-50c0-3.87,7.13-2.73,11-2.73h189c3.87,0,13.24-1.13,13.24,2.73l16.72,50c0,3.87-3.13,7-7,7 H200.84C196.97,287.31,193.84,284.17,193.84,280.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoaccounts);
export default __webpack_public_path__ + "static/media/No accounts.be8848c26c397db495ae01d5e45b091b.svg";
export { ForwardRef as ReactComponent };